import { http } from 'common/services';
import { ENDPOINTS } from 'defaults';

export const getNavigatorDashboard = async () => {
  const { DASHBOARD: endpoint } = ENDPOINTS.NAVIGATOR;
  return http.get(endpoint.name, endpoint.url);
};
